
const SignPrintComponent = () => {

  return <><div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', padding: '20px' }}>
    <div className="text-center">
      Người lập
    </div>
    <div className="text-center">
      Người kiểm tra
    </div>
    <div className="text-center">
      Người duyệt
    </div>
  </div>
    <div style={{ width: '100vw', height: '150px' }}></div>
  </>

}

export default SignPrintComponent